import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import tinycolor from 'tinycolor2';
import {FlexBox, useIsMobile, useScale, useBreakpoint} from '@brg/ui';
import { Endpoints, Project } from '@brg/api';

import { ImagePreviewSection } from '../../components/ImagePreviewSection/ImagePreviewSection';
import { bColor } from '../../../core/utils/bColor';
import { CustomInputProps } from '../../components/inputs/components/dropdown/Dropdown';
import styled from 'styled-components';
import { useResizedImageEnhanced } from "../../hooks/useResizedImageEnhanced";
import {LayoutConst} from "../../../core";
import { SP_VOTE_COLLECTION_SIGN } from '../VotesAdmin/constants';
import { VoteCollectionCover } from './components/VoteCollectionCover/VoteCollectionCover';
import {WarholCardCover, WarholCardCoverEditBg} from "../../components/WarholCardCover/WarholCardCover";
import getImages from './support/getImages';
import { ErrorItem, RequiredErrorMsg, ShadowWarning, WarningText } from './styles';
import { LongreadViewType } from '../../components/ViewTypeController/ViewTypeController';
import { LabelRedStar } from '../designerEditView/styles';
import WarningIcon from 'shared/assets/24/WarningIcon';

type PropsT = {
  project: Project<'Global'>;
  userColor: string;
  imgSrc: string;
  onOpenFileClick: () => void;
  customProps?: CustomInputProps;
  isProjectEdit?: boolean;
  isCompetitionEdit?: boolean;
  errorProjectFill?: boolean;
  longReadLength?: number;
  errorsArray?: string[];
  vtype?: any;
  theme?: any;
};

const InputHolder = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

const PreformattedText = styled(FlexBox)`
  white-space: break-spaces;
` 

const LeftSide: FC<PropsT> = ({
  customProps,
  project,
  userColor,
  imgSrc,
  onOpenFileClick,
  //@ts-ignore
  fileInput,
  isProjectEdit,
  isCompetitionEdit,
  errorProjectFill,
  longReadLength,
  errorsArray,
  vtype,
  theme,
}) => {
  const { t, i18n } = useTranslation();
  const s = useScale();
  const isMobile = useIsMobile();

  const titleImages = getImages(project, i18n.language)
  const is744BP = useBreakpoint(LayoutConst.screen.s);

  const custom = useMemo(
    () => ({
      customTextColor: customProps?.customTextColor,
      customBackgroundColor: bColor.isDark(userColor)
        ? tinycolor(userColor).lighten(10).toHexString()
        : tinycolor(userColor).darken(10).toHexString(),
    }),
    [userColor, customProps]
  );

  // @ts-ignore
  const isAdaptiveCard = useMemo(() => project?.isAdaptiveCard, [project?.isAdaptiveCard])

  const isCollectionVote = useMemo(() => (project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN) && !project?.titleImages?.length), [project])

  const [image, ref] = useResizedImageEnhanced(isAdaptiveCard ? [] : titleImages);

  const imageUrl = useMemo(() => {
    return (ref?.current && image?.url ? `${Endpoints.files}/${image.url}` : '');
  },[ref?.current, image])

  const url = useMemo(() => fileInput.imgSrc || imageUrl, [fileInput.imgSrc, imageUrl]);

  return (
    <InputHolder ref={ref}>
      <ImagePreviewSection
        custom={custom}
        width={s(564)}
        height={s(792)}
        widthMobile={(isCompetitionEdit && !is744BP) ? "432px" : "calc(100vw - 20px)"}
        heightMobile={(isCompetitionEdit && !is744BP) ? "594px" : "calc((100vw - 20px) * 1.407)"}
        buttonHeight={48}
        //@ts-ignore
        fileInput={fileInput}
        url={url}
        placeholderMargin={0}
        placeholderMaxWidth={300}
        placeholderHeight={120}
        isProjectEdit={isProjectEdit}
        isCompetitionEdit={isCompetitionEdit}
        isCollectionVote={isCollectionVote || isAdaptiveCard}
        isAdaptiveCard={isAdaptiveCard}
      >
        {isAdaptiveCard ? <WarholCardCoverEditBg><WarholCardCover project={project}/></WarholCardCoverEditBg> : isCollectionVote ? <VoteCollectionCover project={project}/> : <>
              <>
                {t('project_edit.image.text')}
                <br/>
                {t('project_edit.image.optimal', { height: 1600, width: 1140 })}
              </>
        </>}
      </ImagePreviewSection>
      
      {(errorProjectFill || longReadLength === 0) && (
        <FlexBox direction="column" directionMobile='column' offsetTop={24}>
          <ErrorItem
            color={theme?.projectEdit?.textTips}
            direction="column"
            directionMobile="column"
          >
            <ul>
              {errorsArray?.slice(0, -1).map((error) => (
                <li key={error}>
                  <FlexBox direction='row'>
                    <span style={{ marginRight: 8 }}>{`—`}</span>
                    <span>{`${error}`}</span>
                  </FlexBox>
                </li>
              ))}
            </ul>
          </ErrorItem>
          {!!errorsArray?.length && (
            <FlexBox direction='row' directionMobile='row'>
              <LabelRedStar style={{ marginLeft: 0 }}>*</LabelRedStar>
              <RequiredErrorMsg>{errorsArray[errorsArray.length - 1]}</RequiredErrorMsg>
            </FlexBox>
          )}
        </FlexBox>
      )}
      
      {/* {vtype === LongreadViewType.shadow && (
      {/* {vtype === LongreadViewType.shadow && (
        <ShadowWarning>
          <WarningIcon />
          <WarningText color={theme?.projectEdit?.label}>
            {t('project_edit.longread_shadow_warning')}
          </WarningText>
        </ShadowWarning>
      )} */}
    </InputHolder>
  );
};

export default LeftSide;
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import tinycolor from 'tinycolor2';
import {FlexBox, useIsMobile, useScale, useBreakpoint} from '@brg/ui';
import { Endpoints, Project } from '@brg/api';

import { ImagePreviewSection } from '../../components/ImagePreviewSection/ImagePreviewSection';
import { bColor } from '../../../core/utils/bColor';
import { CustomInputProps } from '../../components/inputs/components/dropdown/Dropdown';
import styled from 'styled-components';
import { useResizedImageEnhanced } from "../../hooks/useResizedImageEnhanced";
import {LayoutConst} from "../../../core";
import { SP_VOTE_COLLECTION_SIGN } from '../VotesAdmin/constants';
import { VoteCollectionCover } from './components/VoteCollectionCover/VoteCollectionCover';
import {WarholCardCover, WarholCardCoverEditBg} from "../../components/WarholCardCover/WarholCardCover";
import getImages from './support/getImages';
import { ErrorItem, RequiredErrorMsg, ShadowWarning, WarningText } from './styles';
import { LongreadViewType } from '../../components/ViewTypeController/ViewTypeController';
import { LabelRedStar } from '../designerEditView/styles';
import WarningIcon from 'shared/assets/24/WarningIcon';

type PropsT = {
  project: Project<'Global'>;
  userColor: string;
  imgSrc: string;
  onOpenFileClick: () => void;
  customProps?: CustomInputProps;
  isProjectEdit?: boolean;
  isCompetitionEdit?: boolean;
  errorProjectFill?: boolean;
  longReadLength?: number;
  errorsArray?: string[];
  vtype?: any;
  theme?: any;
};

const InputHolder = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

const PreformattedText = styled(FlexBox)`
  white-space: break-spaces;
` 

const LeftSide: FC<PropsT> = ({
  customProps,
  project,
  userColor,
  imgSrc,
  onOpenFileClick,
  //@ts-ignore
  fileInput,
  isProjectEdit,
  isCompetitionEdit,
  errorProjectFill,
  longReadLength,
  errorsArray,
  vtype,
  theme,
}) => {
  const { t, i18n } = useTranslation();
  const s = useScale();
  const isMobile = useIsMobile();

  const titleImages = getImages(project, i18n.language)
  const is744BP = useBreakpoint(LayoutConst.screen.s);

  const custom = useMemo(
    () => ({
      customTextColor: customProps?.customTextColor,
      customBackgroundColor: bColor.isDark(userColor)
        ? tinycolor(userColor).lighten(10).toHexString()
        : tinycolor(userColor).darken(10).toHexString(),
    }),
    [userColor, customProps]
  );

  // @ts-ignore
  const isAdaptiveCard = useMemo(() => project?.isAdaptiveCard, [project?.isAdaptiveCard])

  const isCollectionVote = useMemo(() => (project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN) && !project?.titleImages?.length), [project])

  const [image, ref] = useResizedImageEnhanced(isAdaptiveCard ? [] : titleImages);

  const imageUrl = useMemo(() => {
    return (ref?.current && image?.url ? `${Endpoints.files}/${image.url}` : '');
  },[ref?.current, image])

  const url = useMemo(() => fileInput.imgSrc || imageUrl, [fileInput.imgSrc, imageUrl]);

  return (
    <InputHolder ref={ref}>
      <ImagePreviewSection
        custom={custom}
        width={s(564)}
        height={s(792)}
        widthMobile={(isCompetitionEdit && !is744BP) ? "432px" : "calc(100vw - 20px)"}
        heightMobile={(isCompetitionEdit && !is744BP) ? "594px" : "calc((100vw - 20px) * 1.407)"}
        buttonHeight={48}
        //@ts-ignore
        fileInput={fileInput}
        url={url}
        placeholderMargin={0}
        placeholderMaxWidth={300}
        placeholderHeight={120}
        isProjectEdit={isProjectEdit}
        isCompetitionEdit={isCompetitionEdit}
        isCollectionVote={isCollectionVote || isAdaptiveCard}
        isAdaptiveCard={isAdaptiveCard}
      >
        {isAdaptiveCard ? <WarholCardCoverEditBg><WarholCardCover project={project}/></WarholCardCoverEditBg> : isCollectionVote ? <VoteCollectionCover project={project}/> : <>
              <>
                {t('project_edit.image.text')}
                <br/>
                {t('project_edit.image.optimal', { height: 1600, width: 1140 })}
              </>
        </>}
      </ImagePreviewSection>
      
      {(errorProjectFill || longReadLength === 0) && (
        <FlexBox direction="column" directionMobile='column' offsetTop={24}>
          <ErrorItem
            color={theme?.projectEdit?.textTips}
            direction="column"
            directionMobile="column"
          >
            <ul>
              {errorsArray?.slice(0, -1).map((error) => (
                <li key={error}>
                  <FlexBox direction='row'>
                    <span style={{ marginRight: 8 }}>{`—`}</span>
                    <span>{`${error}`}</span>
                  </FlexBox>
                </li>
              ))}
            </ul>
          </ErrorItem>
          {!!errorsArray?.length && (
            <FlexBox direction='row' directionMobile='row'>
              <LabelRedStar style={{ marginLeft: 0 }}>*</LabelRedStar>
              <RequiredErrorMsg>{errorsArray[errorsArray.length - 1]}</RequiredErrorMsg>
            </FlexBox>
          )}
        </FlexBox>
      )}
      
      {/* {vtype === LongreadViewType.shadow && (
      {/* {vtype === LongreadViewType.shadow && (
        <ShadowWarning>
          <WarningIcon />
          <WarningText color={theme?.projectEdit?.label}>
            {t('project_edit.longread_shadow_warning')}
          </WarningText>
        </ShadowWarning>
      )} */}
    </InputHolder>
  );
};

export default LeftSide;
